export default __webpack_public_path__ + "static/media/facebook-marketplace.0de91459.jpg";